export class QOSPageMeasurement {
    successful: boolean;
    description: string;

    success: boolean;

    constructor() {}
}